/* eslint-disable class-methods-use-this */

export default class CopyLink {
  constructor() {
    this.selector = `[data-copy-url]`;
    this.tooltipSelector = `.js-copy-url-tooltip`;
    this.tooltipTime = 3000;

    this.init = this.init.bind(this);
    this.events = this.events.bind(this);
    this.onClick = this.onClick.bind(this);
    this.copyLink = this.copyLink.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.destroy = this.destroy.bind(this);

    this.init();
  }

  init() {
    this.copyLinkButtons = document.querySelectorAll(this.selector);
    this.events();
  }

  events() {
    this.copyLinkButtons.forEach((button) => {
      button.addEventListener('click', this.onClick.bind(this));
    });
  }

  onClick(event) {
    const target = event.currentTarget;
    this.copyLink(target);
    this.showTooltip(target);
  }

  copyLink(target) {
    const link = target ? target.dataset.copyUrl : '';
    navigator.clipboard.writeText(link);
  }

  showTooltip(target) {
    const tooltip = target.querySelector(this.tooltipSelector);
    if (tooltip) {
      tooltip.classList.remove('--inactive');
      tooltip.classList.add('--active');
      setTimeout(() => {
        tooltip.classList.remove('--active');
        tooltip.classList.add('--inactive');
      }, this.tooltipTime);
    }
  }

  destroy() {
    if (this.copyLinkButtons) {
      this.copyLinkButtons.forEach((button) => {
        button.removeEventListener('click', this.onClick.bind(this));
      });
      this.copyLinkButtons = null;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/copyLink.js